/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface AskPasswordUpdateDto
 */
export interface AskPasswordUpdateDto {
    /**
     * 
     * @type {UserIdDto}
     * @memberof AskPasswordUpdateDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the AskPasswordUpdateDto interface.
 */
export function instanceOfAskPasswordUpdateDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function AskPasswordUpdateDtoFromJSON(json: any): AskPasswordUpdateDto {
    return AskPasswordUpdateDtoFromJSONTyped(json, false);
}

export function AskPasswordUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AskPasswordUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function AskPasswordUpdateDtoToJSON(value?: AskPasswordUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': UserIdDtoToJSON(value.userId),
    };
}

